import React from "react";
import styled from "styled-components";
import { SourceProps, SourceType } from "Data/detail";
import SourceImage from "Components/SourceImage";
import SourceVideo from "Components/SourceVideo";
interface GalleryProps {
	data: SourceProps[];
}
const Wrapper = styled.div`
	> div {
		&:not(:last-child) {
			margin-bottom: 16px;
		}
	}
`;
const Gallery: React.FC<GalleryProps> = ({ data }) => {
	return (
		<Wrapper>
			{data.map((el) => {
				return el.type === SourceType.IMAGE ? <SourceImage image={el.value} key={el.id} /> : <SourceVideo source={el.value} key={el.id} />;
			})}
		</Wrapper>
	);
};

export default Gallery;
